import { useMutation } from '@tanstack/react-query';
import postPing from 'Api/monitoring/postPing';

import usePostLogout from 'Domain/logout/usePostLogout';

import postPingPayload from './model/request/postPingPayload';

const usePostPing = () => {
  const { mutate: onLogout } = usePostLogout();

  return useMutation({
    mutationFn: async (formData) => {
      const payload = postPingPayload(formData);

      const result = await postPing(payload);

      return result;
    },
    onSuccess: (response) => {
      const isDeviceIdChanged = response?.result?.isDeviceIdChanged;

      if (isDeviceIdChanged) onLogout({ isReload: false });
    },
    retry: 1000,
    retryDelay: 3000,
  });
};

export default usePostPing;
